document.documentElement.classList.remove('no-js');

const menu = document.querySelector('[data-mobile-menu]');
const menuToggle = document.querySelector('[data-menu-toggle]');
const menuClose = document.querySelector('[data-menu-close]');

// Customer Activity Notification - The Global Customer
const activityNotification = document.getElementById('customer-activity-notification');
const activityLink = activityNotification?.querySelector('[data-activity-link]');
const activityImage = activityNotification?.querySelector('[data-activity-image]');
const activityLabel = activityNotification?.querySelector('[data-activity-label]');
const activityLocation = activityNotification?.querySelector('[data-activity-location]');
const activityProduct = activityNotification?.querySelector('[data-activity-product]');
const activityDismiss = activityNotification?.querySelector('[data-activity-dismiss]');

let activityTimer = null;
let activityHideTimer = null;
let activitySequence = 0;

// 100+ locations for variety
const activityLocations = [
  "Los Angeles, USA", "New York City, USA", "Miami, USA", "Chicago, USA", "Austin, USA",
  "San Francisco, USA", "Seattle, USA", "Denver, USA", "Boston, USA", "Nashville, USA",
  "Toronto, Canada", "Vancouver, Canada", "Montreal, Canada", "Mexico City, Mexico", "Guadalajara, Mexico",
  "São Paulo, Brazil", "Rio de Janeiro, Brazil", "Buenos Aires, Argentina", "Bogotá, Colombia", "Lima, Peru",
  "London, UK", "Manchester, UK", "Birmingham, UK", "Edinburgh, UK", "Glasgow, UK",
  "Paris, France", "Lyon, France", "Marseille, France", "Berlin, Germany", "Munich, Germany",
  "Hamburg, Germany", "Madrid, Spain", "Barcelona, Spain", "Milan, Italy", "Rome, Italy",
  "Amsterdam, Netherlands", "Rotterdam, Netherlands", "Lisbon, Portugal", "Porto, Portugal", "Brussels, Belgium",
  "Antwerp, Belgium", "Copenhagen, Denmark", "Stockholm, Sweden", "Oslo, Norway", "Helsinki, Finland",
  "Zurich, Switzerland", "Geneva, Switzerland", "Vienna, Austria", "Prague, Czechia", "Warsaw, Poland",
  "Athens, Greece", "Dubai, UAE", "Abu Dhabi, UAE", "Riyadh, Saudi Arabia", "Doha, Qatar",
  "Beirut, Lebanon", "Tel Aviv, Israel", "Istanbul, Turkey", "Cape Town, South Africa", "Johannesburg, South Africa",
  "Lagos, Nigeria", "Nairobi, Kenya", "Marrakesh, Morocco", "Cairo, Egypt", "Accra, Ghana",
  "Tokyo, Japan", "Osaka, Japan", "Seoul, South Korea", "Busan, South Korea", "Singapore",
  "Hong Kong", "Taipei, Taiwan", "Bangkok, Thailand", "Kuala Lumpur, Malaysia", "Jakarta, Indonesia",
  "Manila, Philippines", "Sydney, Australia", "Melbourne, Australia", "Brisbane, Australia", "Perth, Australia",
  "Auckland, New Zealand", "Wellington, New Zealand", "Mumbai, India", "Delhi, India", "Bangalore, India",
  "Bali, Indonesia", "Ho Chi Minh City, Vietnam", "Hanoi, Vietnam", "Shanghai, China", "Beijing, China",
];

const activityTemplates = [
  { label: "Just purchased", weight: 40 },
  { label: "Recently bought", weight: 30 },
  { label: "Just ordered", weight: 15 },
  { label: "Picked up", weight: 10 },
  { label: "Grabbed", weight: 5 },
];

function getRandomActivityLabel() {
  const totalWeight = activityTemplates.reduce((sum, t) => sum + t.weight, 0);
  let random = Math.random() * totalWeight;
  for (const template of activityTemplates) {
    random -= template.weight;
    if (random <= 0) return template.label;
  }
  return "Just purchased";
}

// Try to get products from Shopify's global product data
function getAvailableProducts() {
  // Try various ways Shopify stores product data
  if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.products) {
    return window.ShopifyAnalytics.meta.products;
  }
  if (window.meta && window.meta.products) {
    return window.meta.products;
  }
  // Try to find product data in JSON-LD or data attributes
  const productElements = document.querySelectorAll('[data-product-json], [data-product-handle]');
  const products = [];
  productElements.forEach(el => {
    try {
      const data = JSON.parse(el.textContent || el.dataset.productJson || '{}');
      if (data.handle && data.title) {
        products.push({
          handle: data.handle,
          title: data.title,
          featured_image: data.featured_image || data.images?.[0],
          url: `/products/${data.handle}`
        });
      }
    } catch (e) {}
  });
  
  // Fallback: scrape product links from the page
  if (products.length === 0) {
    const productLinks = document.querySelectorAll('a[href*="/products/"]');
    const seen = new Set();
    productLinks.forEach(link => {
      const href = link.getAttribute('href');
      const match = href.match(/\/products\/([^?&#]+)/);
      if (match && !seen.has(match[1])) {
        seen.add(match[1]);
        const img = link.querySelector('img');
        const titleEl = link.querySelector('h3, .product-card-copy h3, [class*="title"], [class*="name"]');
        
        // Fix image URL - ensure it's absolute and handle lazy loading
        let imageUrl = '';
        if (img) {
          imageUrl = img.src || img.dataset.src || img.dataset.image || '';
          // Handle protocol-relative URLs
          if (imageUrl.startsWith('//')) {
            imageUrl = 'https:' + imageUrl;
          }
          // Skip if no valid image
          if (!imageUrl || imageUrl === 'about:blank' || imageUrl.includes('data:image')) {
            imageUrl = '';
          }
        }
        
        // Only add products that have images
        if (imageUrl) {
          products.push({
            handle: match[1],
            title: titleEl ? titleEl.textContent.trim() : match[1].replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase()),
            featured_image: imageUrl,
            url: href
          });
        }
      }
    });
  }
  
  return products;
}

function showActivityNotification() {
  if (!activityNotification || activityNotification.classList.contains('is-disabled')) return;

  const products = getAvailableProducts();
  if (!products.length) return;

  const product = products[activitySequence % products.length];
  const location = activityLocations[(activitySequence * 23) % activityLocations.length];
  const label = getRandomActivityLabel();

  activitySequence++;

  // Update notification content
  if (activityLink) activityLink.href = product.url || `/products/${product.handle}`;
  if (activityImage) {
    activityImage.src = product.featured_image || product.image || '';
    activityImage.alt = product.title || '';
    // Handle image load errors - hide notification if image fails
    activityImage.onerror = () => {
      hideActivityNotification();
    };
  }
  if (activityLabel) activityLabel.textContent = label;
  if (activityLocation) activityLocation.textContent = `A customer in ${location}`;
  if (activityProduct) activityProduct.textContent = `${label.toLowerCase()} ${product.title}`;

  // Show notification
  activityNotification.style.display = 'grid';
  // Force reflow for animation
  activityNotification.offsetHeight;
  activityNotification.classList.add('is-visible');

  // Schedule hide
  activityHideTimer = setTimeout(() => {
    hideActivityNotification();
  }, 9000); // visibleDurationMs

  // Schedule next
  const minDelay = 105000; // minimumRepeatDelayMs
  const rangeDelay = 60000; // repeatDelayRangeMs
  activityTimer = setTimeout(() => {
    showActivityNotification();
  }, minDelay + Math.floor(Math.random() * rangeDelay));
}

function hideActivityNotification() {
  if (!activityNotification) return;
  activityNotification.classList.remove('is-visible');
  setTimeout(() => {
    activityNotification.style.display = 'none';
  }, 300);
}

// Initialize
if (activityNotification && !activityNotification.classList.contains('is-disabled')) {
  // Initial delay
  const initialDelay = 12000; // initialDelayMs
  activityTimer = setTimeout(() => {
    showActivityNotification();
  }, initialDelay);

  // Dismiss button
  activityDismiss?.addEventListener('click', () => {
    hideActivityNotification();
    if (activityTimer) clearTimeout(activityTimer);
    if (activityHideTimer) clearTimeout(activityHideTimer);
    // Schedule next after dismiss
    const minDelay = 105000;
    const rangeDelay = 60000;
    activityTimer = setTimeout(() => {
      showActivityNotification();
    }, minDelay + Math.floor(Math.random() * rangeDelay));
  });
}

function setMenu(open) {
  if (!menu || !menuToggle) return;
  menu.hidden = !open;
  menuToggle.setAttribute('aria-expanded', String(open));
  document.body.classList.toggle('menu-open', open);
}

menuToggle?.addEventListener('click', () => setMenu(menuToggle.getAttribute('aria-expanded') !== 'true'));
menuClose?.addEventListener('click', () => setMenu(false));
document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

document.querySelectorAll('[data-slideshow]').forEach((root) => {
  const slides = [...root.querySelectorAll('[data-slide]')];
  const dots = [...root.querySelectorAll('[data-slide-dot]')];
  const counter = root.querySelector('[data-slide-counter]');
  const pause = root.querySelector('[data-slide-pause]');
  const delay = Number(root.dataset.autoplay) || 7000;
  let index = 0;
  let playing = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  let timer;

  function show(next) {
    index = (next + slides.length) % slides.length;
    slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    dots.forEach((dot, i) => { dot.classList.toggle('is-active', i === index); dot.setAttribute('aria-selected', String(i === index)); });
    if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
  }
  function schedule() { clearInterval(timer); if (playing && slides.length > 1) timer = setInterval(() => show(index + 1), delay); }

  root.querySelector('[data-slide-prev]')?.addEventListener('click', () => { show(index - 1); schedule(); });
  root.querySelector('[data-slide-next]')?.addEventListener('click', () => { show(index + 1); schedule(); });
  dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
  pause?.addEventListener('click', () => { playing = !playing; pause.textContent = playing ? 'PAUSE' : 'PLAY'; schedule(); });
  root.addEventListener('mouseenter', () => clearInterval(timer));
  root.addEventListener('mouseleave', schedule);
  schedule();
});

document.querySelectorAll('[data-product-section]').forEach((section) => {
  const data = section.parentElement.querySelector('[data-product-json]');
  const select = section.querySelector('[data-variant-select]');
  const radios = [...section.querySelectorAll('.product-option input')];
  if (!data || !select || !radios.length) return;
  const variants = JSON.parse(data.textContent);
  const update = () => {
    const chosen = [...new Set(radios.map((radio) => radio.name))].map((name) => radios.find((radio) => radio.name === name && radio.checked)?.value);
    const match = variants.find((variant) => variant.options.every((option, i) => option === chosen[i]));
    if (match) { select.value = String(match.id); history.replaceState({}, '', `${location.pathname}?variant=${match.id}`); }
  };
  radios.forEach((radio) => radio.addEventListener('change', update));
});
